import React from 'react';
import { ProtectedRoute } from '@/components';
import Guide from './guide';

export default {
  path: 'guide',
  element: <ProtectedRoute component={<Guide />} />,
};
